
import {createSlice} from "@reduxjs/toolkit";

export const userProfileSlice = createSlice({
    name: 'userProfileSlc',
    initialState: {
            value: {id: 0, firstName: null, lastName: null, department: null,
                role: null, rights: null, status: null, approvalLimit: null, userName: null,
                createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null

            }},

    reducers:
{
    changeUserProfile: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeUserProfile } = userProfileSlice.actions;

export default  userProfileSlice.reducer ;
